/** 登录成功后暂存待展示公告的 sessionStorage key */
const PENDING_ANNOUNCEMENT_KEY = "comic_ai_pending_announcement";

/**
 * 校验登录接口返回的公告结构是否可展示
 * @param {unknown} announcement
 * @returns {boolean}
 */
export function isValidAnnouncement(announcement) {
  if (!announcement || typeof announcement !== "object") {
    return false;
  }
  const id = announcement.id;
  return id !== undefined && id !== null && String(id).trim() !== "";
}

/**
 * 登录成功后写入待展示公告（关闭弹窗前保留，刷新仍可再次弹出）
 * @param {object|null|undefined} announcement
 */
export function savePendingAnnouncement(announcement) {
  if (typeof window === "undefined" || !window.sessionStorage) {
    return;
  }
  if (!isValidAnnouncement(announcement)) {
    clearPendingAnnouncement();
    return;
  }
  try {
    window.sessionStorage.setItem(
      PENDING_ANNOUNCEMENT_KEY,
      JSON.stringify({
        id: announcement.id,
        title: announcement.title || "",
        content: announcement.content || "",
        publishTime: announcement.publishTime || "",
        projectVersion: announcement.projectVersion || "",
      }),
    );
  } catch (error) {
    // sessionStorage 不可用时静默跳过，不影响登录主流程
  }
}

/**
 * 读取待展示公告（不删除，关闭弹窗后再清）
 * @returns {object|null}
 */
export function peekPendingAnnouncement() {
  if (typeof window === "undefined" || !window.sessionStorage) {
    return null;
  }
  try {
    const raw = window.sessionStorage.getItem(PENDING_ANNOUNCEMENT_KEY);
    if (!raw) {
      return null;
    }
    const data = JSON.parse(raw);
    return isValidAnnouncement(data) ? data : null;
  } catch (error) {
    return null;
  }
}

/** 用户关闭公告弹窗后清除暂存，避免同会话重复弹出 */
export function clearPendingAnnouncement() {
  if (typeof window === "undefined" || !window.sessionStorage) {
    return;
  }
  try {
    window.sessionStorage.removeItem(PENDING_ANNOUNCEMENT_KEY);
  } catch (error) {
    // ignore
  }
}
